// extracted by mini-css-extract-plugin
export var card = "_lv-0";
export var content = "_lv-2";
export var details = "_lv-3";
export var icon = "_lv-1";
export var iconBlue = "_lv-5";
export var iconBrand = "_lv-4";
export var iconGrayBlue = "_lv-6";
export var iconGreen = "_lv-7";
export var iconIndigo = "_lv-8";
export var iconOrange = "_lv-9";
export var iconPurple = "_lv-a";
export var iconRed = "_lv-b";
export var iconWarning = "_lv-c";